module.exports = __webpack_public_path__ + "img/Illustration-solution@3x.bca3dba.png";